<template>
	<div>
		<div class="header" :style="'background-color:' + gcfg.BackgroundColor">
			<div class="myheader" :style="'color:' + gcfg.TopTextColor"
				style="text-align: center;font-size: 0.8em; padding-top: 1em; margin-bottom: 1.8em;">
				<div class="bicon"></div>
				<h3>个人中心</h3>
				<div class="bicon" @click="goShezhi">
					<van-icon name="setting-o" />
				</div>
			</div>
			<div class="avatar">
				<img style="width: 100%;" :src='user.avatar'>
			</div>
			<div class="account" :style="'color:' + gcfg.TopTextColor">
				<van-button style="margin-bottom: 1em;" plain type="primary" size="small" v-if="third == null"
					@click="binding_wx">绑定微信</van-button>
				<div v-else class="showname">
					{{ user.nickname }}
					<div class="showid">
						ID：{{ padding2(user.id, 8) }}
					</div>
				</div>
			</div>
		</div>
		<div class="item-box">
			<van-grid clickable :column-num="3" :border="false">
				<van-grid-item text="店铺中心" to="shopsetting" v-if="store != null && store.status == 'normal'">
					<template #icon>
						<van-icon name="shop-o" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>
				<van-grid-item :text="storeText" @click="onStoreApply" v-if="store == null || store.status != 'normal'">
					<template #icon>
						<van-icon name="records" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>
				<van-grid-item :text="distributorText" @click="onDistri">
					<template #icon>
						<van-icon name="cluster-o" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>
				<van-grid-item text="供应商" to="supplier" v-if="supplier != null && supplier.status == 'normal'">
					<template #icon>
						<van-icon name="passed" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>
				<!--				<van-grid-item text="浏览记录" to="collect?n=2">
					<template #icon>
						<van-icon name="browsing-history-o" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>-->
				<van-grid-item :text="guideText" @click="onGuideStatus" v-if="guide != null && guide.status == 'normal'">
					<template #icon>
						<van-icon name="service-o" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>
				<van-grid-item text="红包" to="hbList">
					<template #icon>
						<van-icon name="balance-pay" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>
				<van-grid-item text="优惠券" to="mycoupon">
					<template #icon>
						<van-icon name="coupon-o" size="28" color="#fe7708" style="font-weight: 600;" />
					</template>
				</van-grid-item>
			</van-grid>
		</div>
		<div class="ddbox">
			<van-cell title="我的订单" is-link value="全部" @click="goOder('0')" />
			<van-grid clickable :column-num="4" :border="false">
				<van-grid-item @click="goOder('1')">
					<van-badge>
						<template #content v-if="datanum.NoConfirmNum > 0">
							<div class="van-badge van-badge--fixed">
								{{ datanum.NoConfirmNum }}
							</div>
						</template>
						<van-icon class="van-grid-item__icon" name="paid" />
					</van-badge>
					<span class="van-grid-item__text">待确认</span>
				</van-grid-item>
				<van-grid-item @click="goOder('2')">
					<van-badge>
						<template #content v-if="datanum.NoPayNum > 0">
							{{ datanum.NoPayNum }}
						</template>
						<van-icon class="van-grid-item__icon" name="pending-payment" />
					</van-badge>
					<span class="van-grid-item__text">待支付</span>
				</van-grid-item>
				<van-grid-item @click="goOder('3')">
					<van-badge>
						<template #content v-if="datanum.NoUseNum > 0">
							{{ datanum.NoUseNum }}
						</template>
						<van-icon name="records" class="van-grid-item__icon" />
					</van-badge>
					<span class="van-grid-item__text">待核销</span>
				</van-grid-item>
				<van-grid-item @click="goOder('4')">
					<van-badge>
						<template #content v-if="datanum.FinishNum > 0">
							{{ datanum.FinishNum }}
						</template>
						<van-icon class="van-grid-item__icon" name="sign" />
					</van-badge>
					<span class="van-grid-item__text">已完成</span>
				</van-grid-item>

			</van-grid>
		</div>
		<div class="ddbox">
			<van-cell title="服务中心" />
			<van-grid clickable :column-num="4" :border="false">
				<van-grid-item text="公众号" icon="qr" to="follow"></van-grid-item>
				<!-- <van-grid-item icon="paid" to="wirteoff" class="textred" v-if="supplier != null && supplier.status =='normal'">
						<van-icon class="van-grid-item__icon" name="sign" />
						<span class="van-grid-item__text" style="color: #ff0000;">快速核销</span>
				</van-grid-item> -->
				<van-grid-item icon="star-o" text="我的收藏" to="collect?n=1"></van-grid-item>
				<van-grid-item icon="service-o" text="联系我们" to="about?place=98"></van-grid-item>
				<van-grid-item icon="info-o" text="关于我们" to="about?place=99"></van-grid-item>
			</van-grid>
		</div>

		<Copyright style="margin-top:4em"></Copyright>

		<!-- <BottomTabbar :curactive="2"></BottomTabbar> -->
		<cube-view></cube-view>
		<!-- <hbll></hbll> -->
	</div>
</template>

<script>
import CubeView from '@/components/TP/cube-view'
import * as util from '@/utils/network'
import BottomTabbar from '@/components/TP/BottomTabbar'
import Copyright from '@/components/TP/Copyright'
import config from '../../vue.config.js'
import hbll from "@/components/TP/hongbao";
import {
	Dialog
} from 'vant';
export default {
	inject: ['reload'],
	data() {
		return {
			showPopover: false,
			actions: [{
				text: '退出登录'
			}],
			gcfg: [],
			id: this.$route.query.id,
			NewsData: [],
			user: [],
			third: null,
			datanum: [],
			store: {},
			supplier: {},
			distributor: {},
			distributorText: '分销申请',
			storeText: '店主申请',
			guide: {},
			guideText: '导游申请'
		}
	},
	components: {
		CubeView,
		BottomTabbar,
		Copyright,
		hbll
	},
	methods: {
		//递归方式实现
		padding2(num, length) {
			for (var len = (num + "").length; len < length; len = num.length) {
				num = "0" + num;
			}
			return num;
		},
		goShezhi() {
			this.$router.push({
				name: 'logout'
			})
		},
		goOder(v) {
			//url跳转
			util.redirect('myorder/list?showType=' + v);
			// this.$router.push({
			// 	name: 'OrderMy',
			// 	params: {
			// 		showType: v
			// 	}
			// })
		},
		// 退出登录
		selectPopover(v) {
			let that = this
			if (v.text == '退出登录') {
				Dialog.confirm({
					title: '温馨提示',
					message: '确定要退出登录吗？',
				})
					.then(() => {
						util.post('/addons/litestore/api.account/logout', {},
							function (result) {
								Dialog.alert({
									title: '温馨提示',
									message: result.msg,
								}).then(() => {
									that.$store.commit('logOut');
									console.log(result);
									window.location.href = result.data;
									/*return false;
									that.reload(); //此处刷新页面*/
								});
								// this.$store.commit('logOut');
							}
						);
					})
					.catch(() => {
						// on cancel
					});
			}
		},
		onStoreApply() {
			let that = this
			if (that.store == null) {
				this.$router.push({
					path: '/settingxq'
				})
			} else {
				if (that.store.status == 'pending') {
					Dialog.alert({
						title: '温馨提示',
						message: '正在审核中...',
					}).then(() => {
						// on close
					});
				} else if (that.store.status == 'refuse') {
					this.$router.push({
						path: '/settingxq'
					})
				}
			}
		},
		// 分销商审核中
		onDistri() {
			let that = this
			if (that.distributor == null || that.distributor.status == 'refuse') {
				this.$router.push({
					path: '/disAppr'
				})
			} else {
				if (that.distributor.status == 'pending') {
					Dialog.alert({
						title: '温馨提示',
						message: '正在审核中...',
					}).then(() => {
						// on close
					});
				}
				if (that.distributor.status == 'normal') {
					this.$router.push({
						path: '/distributor'
					})
				}
			}
		},
		// 导游状态判断
		onGuideStatus() {
			if (this.guide == null || this.guide.status == 'refuse') {
				this.$router.push({
					path: '/guideApply', //去申请
				})
			} else {
				if (this.guide.status == 'pending') {
					Dialog.alert({
						title: '温馨提示',
						message: '正在审核中...',
					}).then(() => {
						// on close
					});
				}
				if (this.guide.status == 'normal') {
					this.$router.push({
						path: '/guideHome' //去导游主页
					})
				}
			}
		},
		axios_Request() {
			var url = "/addons/litestore/api.uservue/index"
			let that = this;
			//这里直接调用网络接口
			util.get(url, {},
				function (result) {
					that.distributor = result.data.distributor;
					that.guide = result.data.guider;
					that.datanum = result.data.orderGroup;
					that.user = result.data.user;
					that.third = result['data']['third']
					that.store = result.data.store;
					that.supplier = result.data.supplier;
					if (that.distributor != null) {
						that.$store.commit('setDistributor', {
							id: result.data.distributor.id,
							status: result.data.distributor.status
						})

						if (that.distributor.status == 'pending') {
							that.distributorText = '审核中'
						} else if (that.distributor.status == 'refuse') {
							that.distributorText = '已拒绝'
						} else if (that.distributor.status == 'disable') {
							that.distributorText = '已禁用'
						} else if (that.distributor.status == 'normal') {
							that.distributorText = '分销商'
						}

					}
					if (that.guide != null) {

						if (that.guide.status == 'pending') {
							that.guideText = '审核中'
						} else if (that.guide.status == 'refuse') {
							that.guideText = '已拒绝'
						} else if (that.guide.status == 'disable') {
							that.guideText = '已禁用'
						} else if (that.guide.status == 'normal') {
							that.guideText = '导游'
						}
					}
					if (that.store != null) {
						that.$store.commit('setShop', result.data.store.id)
						if (that.store.status == 'pending') {
							that.storeText = '审核中'
						} else if (that.store.status == 'refuse') {
							that.storeText = '已拒绝'
						} else if (that.store.status == 'disable') {
							that.storeText = '已禁用'
						}
					}
				},
			);
		},
		binding_wx() {
			var urltmp = 'http://' + window.location.host +
				'/addons/litestore/api.uservue/connect?platform=wechat&url=' +
				'http://' + window.location.host + '/addons/litestore/octothorpe/My';

			window.location.href = urltmp
		}
	},
	created() {
		this.axios_Request();
		this.gcfg = this.$store.getters.getGcfg
	},
	watch: {
		"$store.state.gcfg"() {
			this.gcfg = this.$store.getters.getGcfg
		}
	},
}
</script>

<style lang="less">
.myheader {
	display: flex;
	justify-content: center;
	align-items: center;

	h3 {
		flex: 1;
		text-align: center;
	}

	.bicon {
		width: 75px;
		font-size: 20px;
		font-weight: 600;
	}
}

.item-box {
	padding: 10px;
	box-sizing: border-box;
}

.ddbox {
	margin: 10px 10px 0;
	box-sizing: border-box;
	/* background-color: #FFFFFF; */
	border-radius: 15px;
	box-shadow: 0 0 5px #e2e2e2;
}

.header {
	width: 100%;
	/* background: #6d189e; */
	top: 0;
}

.header .avatar {
	border-radius: 50%;
	overflow: hidden;
	width: 80px;
	height: 80px;
	text-align: center;
	background: #fff;
	margin: 15px auto;
	border: 2px solid #fff;
	box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
}

.header .avatar image {
	width: 100%;
	height: 100%;
}

.header .account {
	color: #fff;
	text-align: center;
}

.showname {
	font-size: 1.2em;
	padding-bottom: 0.8em;

	.showid {
		padding-top: 5px;
		font-size: 14px;
		color: #5f5f5f;
	}
}

.title-footer .cont {
	background-color: #f8f8f8;
}

.buttons_froup {
	margin-top: 1em;
}

.title-footer {
	margin-top: 1em;
}

.van-cell__left-icon,
.van-cell__right-icon {
	font-size: 1.5em;
	color: #6d189e;
}

.tag-c-c {
	margin-left: 1em;
}
</style>
<style lang="less" scoped>
/deep/ .van-grid-item__content {
	padding: 10px 8px;
}
</style>
